export const formatImageUrl = (
  node: { image?: string | { url: string }[] },
  useCDN = true,
  noCache = true,
  useFallback = false,
): string => {
  let url = '';
  if (typeof node?.image === 'string') {
    url = `${node.image}`;
  } else if (Array(node?.image)) {
    url = node.image?.[1] ? node.image[1].url : '';
  }
  if (useCDN) {
    url = url.replace('www.benzinga.com', 'cdn.benzinga.com');
  }
  if (noCache) {
    const regEx = new RegExp('/imagecache(.*)/images');
    url = url.replace(regEx, '/images');
  }
  if (!url && useFallback) {
    return BENZINGA_BZ_IMAGE_SHORT;
  }
  return url;
};

export const BENZINGA_BZ_IMAGE_SHORT =
  'https://cdn.benzinga.com/files/imagecache/bz2_opengraph_meta_image_400x300/sites/all/themes/bz2/images/bz-icon.png';

export const BENZINGA_BZ_IMAGE_LONG = 'https://cdn.benzinga.com/files/images/story/2025/07/18/bz-placeholder.png';

export const BENZINGA_AUTHOR_NO_PICTURE_URL = 'https://editorial-assets.benzinga.com/author-profiles/no_picture.png';

/** Author profile image URL from API (absolute); empty uses fallback avatar. */
export const formatAuthorPictureUrl = (
  picture: string | null | undefined,
  fallbackUrl: string = BENZINGA_AUTHOR_NO_PICTURE_URL,
): string => {
  const trimmed = typeof picture === 'string' ? picture.trim() : '';
  return trimmed ? trimmed : fallbackUrl;
};
